



























import type { Currency } from '@getaccept/lib-shared/src/types/Currency';
import type { PropType } from '@vue/composition-api';
import { computed, defineComponent } from '@vue/composition-api';
import { DateTime } from 'luxon';
import { t } from '@getaccept/lib-shared/src/helpers/translation.helper';
import DashboardEmptyStateText from '../../../../components/DashboardEmptyStateText.vue';
import DashboardWidgetList from '../../../../components/DashboardWidgetList.vue';
import DashboardWidgetListSkeleton from '../../../../components/skeletons/DashboardWidgetListSkeleton.vue';
import TopPerformersWidgetItem from '../../../../components/widgets/top-performers/TopPerformersWidgetItem.vue';
import { DashboardWidgetHeaderColor } from '../../../../types/enums/dashboard-widget-header-color';
import { useTopPerformers } from '../composables/top-performers.composable';

export default defineComponent({
  name: 'TopPerformersWidget',
  components: {
    DashboardWidgetList,
    TopPerformersWidgetItem,
    DashboardEmptyStateText,
    DashboardWidgetListSkeleton,
  },
  props: {
    currency: {
      type: Object as PropType<Currency>,
      default: null,
    },
  },
  setup() {
    const interval = {
      from: DateTime.now().toUTC().startOf('month').toMillis(),
      to: DateTime.now().toUTC().endOf('month').toMillis(),
    };

    const { data, isSuccess, isLoading } = useTopPerformers(interval);

    const topValue = computed(() => (data ? data.value[0]?.value : 0));

    return {
      data,
      isSuccess,
      isLoading,
      topValue,
      DashboardWidgetHeaderColor,
      t,
    };
  },
});
